import Vue from 'vue'
import axios from 'axios'
import configs from '../../axios.config'
import i18n from './i18n/index'
import Toast from 'vue-toastification'


const axiosIns = axios.create({
  baseURL: configs.baseURL,
  timeout: 20000,
  headers: {
    // "ngrok-skip-browser-warning": true,
    // "ngrok-skip-browser-warning": "69420"
  }
})



const axiosIns2 = axios.create({
  baseURL: 'http://zk.leocrm.uz:82/api/v2',
  // baseURL: 'http://192.168.31.82:8002/api/v2',
  timeout: 20000,
})





axiosIns.interceptors.request.use(function(request){
  if(localStorage.getItem('lang')){
    request.headers["Lang"] = localStorage.getItem('lang')
    
  }
  return request
})




let _timerId = 0;



axiosIns.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log(error.response)



    // clearTimeout(_timerId)
    // _timerId = setTimeout(async () => {
    //     axiosIns2({
    //       url: 'project/statistic_card_history/create_error_log/',
    //       method: 'POST',
    //       data: {
    //         method: error.response.config.method,
    //         base_url: error.response.config.baseURL + error.response.config.url,
    //         message: error.response.statusText,
    //         status: error.response.status,
    //         params: error.response.config.params,
    //         data: error.response.data,
    //         headers: error.response.headers,
    //         project_name: "Inventory",
    //         project_id: 11,
    //         user_id: 1
    //       }
    //     })
    //     .then(res => {
    //       console.log(res.data)
    //     })
    //     .catch(e => {
    //       console.log(e)
    //     })
    // }, 10000)



    if(error.message == 'Network Error'){
      Vue.$toast.error(i18n.$t('general.network_error'))
    }
    if(error && error.hasOwnProperty('message') && error.message.includes('timeout')){
      Vue.$toast.error('Network Error')
    }


    if (error && error.response && error.response.status == '401' && !window.location.href.includes('login')) {
      localStorage.removeItem('accessWAREHOUSE')
      localStorage.removeItem('refreshWAREHOUSE')
      localStorage.removeItem('userDataWAREHOUSE')
      localStorage.removeItem('abilityWAREHOUSE')
      router.push({name: 'login'})
    }
    return Promise.reject(error);
  },
);



Vue.prototype.$http = axiosIns

export default axiosIns
